

import Echo from "laravel-echo";
import Pusher from "pusher-js";
import axios from "axios";

// @ts-ignore
window.Pusher = Pusher;

let echoInstance: Echo<any> | null = null;
let lastToken: string | null = null;
let authFailureHandler: (() => void) | null = null;

export function setAuthFailureHandler(handler: () => void) {
    authFailureHandler = handler;
}

export function initEcho() {
    const token = localStorage.getItem("dchatToken");

    // se já existe e é o mesmo token, não recria
    if (echoInstance && lastToken === token) {
        // @ts-ignore
        window.websockets = echoInstance;
        return echoInstance;
    }

    // se existe mas token mudou, derruba e recria
    if (echoInstance) {
        try {
            echoInstance.disconnect();
        } catch {}
        echoInstance = null;
    }

    lastToken = token;

    echoInstance = new Echo({
        broadcaster: "reverb",
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
        wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? "https") === "https",
        enabledTransports: ["ws", "wss"],
        encrypted: true,
        disableStats: true,
        authorizer: (channel: any) => ({
            authorize: (socketId: string, callback: (error: Error | null, data: any) => void) => {
                axios.post(import.meta.env.VITE_REVERB_AUTH_URL, {
                    socket_id: socketId,
                    channel_name: channel.name,
                })
                    .then(response => callback(null, response.data))
                    .catch(error => {
                        callback(error, null);
                        if (authFailureHandler) {
                            authFailureHandler();
                        }
                    });
            }
        })
    });

    // @ts-ignore
    window.websockets = echoInstance;

    return echoInstance;
}

export function destroyEcho() {
    if (!echoInstance) return;
    try {
        echoInstance.disconnect();
    } catch {}
    echoInstance = null;
    lastToken = null;
    authFailureHandler = null;

    // @ts-ignore
    window.websockets = undefined;
}


